// Generated by `npm run data:narw-calving` (scripts/data/narwCalving.ts) from
// NOAA Fisheries' page on the 2026 calving season in data/narw-calving-2026/.
// Do not edit by hand: change the script and run it. tests/rightwhale.test.ts
// builds it again and fails if this file is not what the archive gives.

/**
 * NOAA Fisheries, North Atlantic Right Whale Calving Season 2026, https://www.fisheries.noaa.gov/national/endangered-species-conservation/north-atlantic-right-whale-calving-season-2026: each of the season's 23 calves on the day it and its
 * mother were first seen (the latest it can have been born on), earliest
 * first, as the page gives them.
 */
export const CALVES_FIRST_SEEN_2026: readonly string[] = ["2025-11-28","2025-12-03","2025-12-04","2025-12-10","2025-12-11","2025-12-16","2025-12-17","2025-12-20","2025-12-21","2025-12-23","2025-12-23","2025-12-26","2025-12-27","2025-12-27","2026-01-01","2026-01-05","2026-01-08","2026-01-08","2026-01-16","2026-01-20","2026-01-22","2026-01-30","2026-03-14"];
